export default __webpack_public_path__ + "static/media/Ramp_8x4_Inverted.256.bbf0a2a3.png";